import axios from 'axios';
import { authHeader } from './authHeader';

export const getApiInstance = (useHeaders = true, extraHeader?) => {
  console.debug('init API Instance');
  let param = {
    baseURL: process.env.REACT_APP_API,
  };
  if (useHeaders) {
    param['headers'] = authHeader();
  }
  if (extraHeader) {
    param['headers'] = { ...param['headers'], ...extraHeader };
  }

  const apiInstance = axios.create(param);

  return apiInstance;
};
